<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>LISTADO DE TRABAJOS DISPONIBLES</h6>
        </div>
        <div class="col">
          <button  class="btn bg-gradient-success float-end" @click="$router.push('/create-jobs')"> Crear nuevo trabajo</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="row justify-content-end">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <input type="text" class="form-control" placeholder="Buscar por nombre" v-model="pagination.search" @keyup="manualSearch">
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
          <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover table-sm border table-bordered shadow-sm">
          <thead class="bg-light">
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cargo</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Postulado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ubicación</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Sueldo / Pago</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in array_jobs" :key="item._id">
            <td>
              <div class="d-flex px-2 py-1">
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="mb-0 text-sm">{{ item.detalles_oferta?.nombre_cargo || item.name }}</h6>
                  <p class="text-xs text-secondary mb-0">{{ item.detalles_oferta?.tipo_empleo || 'Oferta Laboral' }}</p>
                </div>
              </div>
            </td>
            <td>
              <span class="text-sm font-weight-bold">{{ item.datos_postulado?.nombre_completo || 'No asignado' }}</span>
            </td>
            <td>
              <span class="text-xs font-weight-bold">{{ item.detalles_oferta?.ubicacion_cargo || item.location }}</span>
            </td>
            <td>
              <div class="d-flex flex-column">
                <span class="text-sm font-weight-bold text-success">
                  {{ item.detalles_oferta?.promedio_salarial_anual ? '$' + item.detalles_oferta.promedio_salarial_anual.toLocaleString() + ' Anual' : item.salary }}
                </span>
                <span v-if="item.beneficios?.pago_semanal_total" class="text-xxs text-secondary">
                  (${{ item.beneficios.pago_semanal_total.toLocaleString() }} sem.)
                </span>
              </div>
            </td>
            <td class="align-middle text-center">
              <button class="btn btn-link text-info px-3 mb-0" @click="editItem(item)">
                <i class="fas fa-edit me-2"></i>Editar
              </button>
              <button class="btn btn-link text-danger text-gradient px-3 mb-0" @click="deleteItem(item)">
                <i class="far fa-trash-alt me-2"></i>Borrar
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <p class="text-xs font-weight-bold mb-0">total rows: {{pagination.totalRows}}</p>
        </div>
        <div>
          <v-pagination
              v-model="pagination.page"
              :pages="pagination.pages"
              :range-size="1"
              active-color="#DCEDFF"
              @update:modelValue="reloadPaginate"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import {get, post} from "@/utils/httpRequest";

export default {
  data: () => ({
    array_jobs: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
  }),
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    async getData(){
      const {data} = await get(`job-offers?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`, null)
      this.array_jobs = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    editItem(item){
      this.$router.push({name:'edit-jobs', query: {id: item._id}})
    },
    async deleteItem(item){
      await Swal.fire({
        title: 'Esta seguro?',
        text: "No podras revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#82d616',
        cancelButtonColor: '#d33',
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("job-offers/remove",{_id : item._id})
          await this.getData()
          await Swal.fire('Informacion eliminada correctamente', '', 'success')
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
